import React from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

// Field used on the signup and login forms

const ReduxTextArea = ({
  input,
  label,
  type,
  icon,
  meta: { touched, error, warning },
}) => (
  <div className="field">
    <Form.TextArea
      error={touched && error !== undefined}
      type={type}
      size="big"
      {...input}
      placeholder={label}
    />
    {touched &&
      (error && (
        <Message negative compact>
          {error}
        </Message>
      ))}
  </div>
);

ReduxTextArea.defaultProps = {
  icon: null,
  label: null,
  type: null,
  meta: null,
};

ReduxTextArea.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  meta: PropTypes.object,
};

export default ReduxTextArea;



// WEBPACK FOOTER //
// ./src/containers/Signup/components/ReduxTextArea/index.jsx